/* RIVA: recomendaciones dinamicas "Completa tu pedido" en el carrito.
   Sustituye el upsell de producto fijo por 3 productos relacionados con el
   ultimo articulo añadido (mismo tipo / complementarios), usando el motor
   nativo de recomendaciones de Shopify (/recommendations/products.json).
   Se auto-monta cada vez que el drawer se re-renderiza (cart-drawer.js
   reemplaza el innerHTML de #CartDrawer, lo que vuelve a conectar este
   custom element y dispara connectedCallback con el carrito actualizado). */
(function () {
  if (customElements.get('riva-cart-upsell')) return;

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || '${{amount}}';

    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    function withDelimiters(number, precision, thousands, decimal) {
      precision = defaultTo(precision, 2);
      thousands = defaultTo(thousands, ',');
      decimal = defaultTo(decimal, '.');
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsPart = parts[1] ? decimal + parts[1] : '';
      return dollars + centsPart;
    }

    var match = formatString.match(placeholderRegex);
    var key = match ? match[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals':
        value = withDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = withDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = withDelimiters(cents, 0, '.', ',');
        break;
      default:
        value = withDelimiters(cents, 2);
    }
    return match ? formatString.replace(placeholderRegex, value) : value;
  }

  class RivaCartUpsellEl extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-riva-upsell-track]');
      this.moneyFormat = this.getAttribute('data-money-format') || '${{amount}}';
      if (!this.track) return;
      this.load();
    }

    async load() {
      var cart;
      try {
        var cartRes = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        cart = await cartRes.json();
      } catch (err) {
        this.hidden = true;
        return;
      }

      if (!cart || !cart.items || !cart.items.length) {
        this.hidden = true;
        return;
      }

      var excludeIds = {};
      cart.items.forEach(function (item) {
        excludeIds[item.product_id] = true;
      });
      var focusProductId = cart.items[cart.items.length - 1].product_id;

      var products = [];
      try {
        products = await this.fetchRecommendations(focusProductId, excludeIds);
      } catch (err) {
        products = [];
      }

      if (!products.length) {
        this.hidden = true;
        return;
      }

      this.hidden = false;
      this.renderCards(products.slice(0, 3));
    }

    async fetchRecommendations(productId, excludeIds) {
      var seen = {};
      var combined = [];

      var fetchIntent = async function (intent) {
        try {
          var res = await fetch(
            '/recommendations/products.json?product_id=' + encodeURIComponent(productId) +
            '&limit=8&intent=' + intent
          );
          if (!res.ok) return [];
          var data = await res.json();
          return (data && data.products) || [];
        } catch (err) {
          return [];
        }
      };

      var intents = ['complementary', 'related'];
      for (var i = 0; i < intents.length; i++) {
        if (combined.length >= 3) break;
        var list = await fetchIntent(intents[i]);
        for (var j = 0; j < list.length; j++) {
          var p = list[j];
          if (combined.length >= 6) break;
          if (excludeIds[p.id] || seen[p.id]) continue;
          if (p.available === false) continue;
          seen[p.id] = true;
          combined.push(p);
        }
      }
      return combined;
    }

    renderCards(products) {
      var self = this;
      this.track.innerHTML = products.map(function (p) {
        return self.cardHTML(p);
      }).join('');
      this.track.querySelectorAll('[data-riva-upsell-add]').forEach(function (btn) {
        btn.addEventListener('click', self.addToCart.bind(self));
      });
    }

    cardHTML(p) {
      var variant = p.variants && p.variants[0];
      var variantId = variant ? variant.id : p.id;
      var available = variant ? variant.available !== false : p.available !== false;
      var image = p.featured_image || (p.images && p.images[0]) || '';
      if (image) {
        image += (image.indexOf('?') === -1 ? '?' : '&') + 'width=200';
      }
      var price = formatMoney(p.price, this.moneyFormat);
      var title = escapeHtml(p.title);

      return (
        '<div class="riva-cart-upsell__card" role="listitem">' +
          '<a href="' + p.url + '" class="riva-cart-upsell__media" tabindex="-1" aria-hidden="true">' +
            (image
              ? '<img src="' + image + '" alt="" loading="lazy" width="120" height="120">'
              : '') +
          '</a>' +
          '<div class="riva-cart-upsell__info">' +
            '<a href="' + p.url + '" class="riva-cart-upsell__name">' + title + '</a>' +
            '<span class="riva-cart-upsell__price">' + price + '</span>' +
          '</div>' +
          '<button' +
            ' type="button"' +
            ' class="riva-cart-upsell__add"' +
            ' data-riva-upsell-add' +
            ' data-variant-id="' + variantId + '"' +
            ' aria-label="Añadir ' + title + ' a la cesta"' +
            (available ? '' : ' disabled') +
          '>' +
            '<span class="riva-cart-upsell__add-label">' + (available ? '+ Añadir' : 'Agotado') + '</span>' +
            '<span class="riva-cart-upsell__spinner" aria-hidden="true"></span>' +
          '</button>' +
        '</div>'
      );
    }

    async addToCart(evt) {
      var btn = evt.currentTarget;
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      btn.disabled = true;
      btn.classList.add('loading');

      var drawer = document.querySelector('cart-drawer');
      var sectionIds = ['cart-drawer', 'cart-icon-bubble'];
      try {
        if (drawer && typeof drawer.getSectionsToRender === 'function') {
          sectionIds = drawer.getSectionsToRender().map(function (s) { return s.id; });
        }
      } catch (err) {}

      try {
        var res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: 1 }],
            sections: sectionIds,
            sections_url: window.location.pathname
          })
        });
        var data = await res.json();

        if (data && data.status) {
          throw new Error(data.description || data.message || 'add_to_cart_error');
        }

        var rendered = false;
        try {
          if (drawer && typeof drawer.renderContents === 'function' && data.sections && data.sections['cart-drawer']) {
            drawer.renderContents(data);
            rendered = true;
          }
        } catch (err) {
          rendered = false;
        }

        try {
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'riva-cart-upsell', cartData: data });
          }
        } catch (err) {}

        if (!rendered) {
          window.location.reload();
        }
      } catch (err) {
        btn.disabled = false;
        btn.classList.remove('loading');
      }
    }
  }

  customElements.define('riva-cart-upsell', RivaCartUpsellEl);
})();
